export const cssSize = (size, unit = "px") => {
  if (typeof size === "string" && /(px|rem|em|ch|vh|vw|pt|%)$/.test(size)) {
    return size;
  }

  if (typeof size === "number") {
    return `${size}${unit}`;
  }

  return size;
};

export const cssColor = (color) => {
  if (!color) return color;
  if (
    color.includes("#") ||
    color.includes("rgb") ||
    color.includes("rgba") ||
    color.includes("hls") ||
    color.includes("hlsa") ||
    color.includes("var(--")
  ) {
    return color;
  }

  if (color.includes("cui-bg-") || color.includes("cui-text-") || color.includes("cui-border-")) {
    return `var(--${color.replace(/cui-(bg|text|border)-/,"")})`;
  }
  return `var(--${color})`;
};

export const cssRadius = (radius) => {
  return `var(--${radius})`;
};
